module.exports = __webpack_public_path__ + "cocos-island.svg?a9001e3c57b986ecdf4126abaa3b711a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/cocos-island.svg
// module id = 137
// module chunks = 10